import {Action, createReducer, on} from "@ngrx/store";
import {initialState} from "./interface.state";
import {interfaceActions} from "./interface.actions";
import {FileUploadStatus} from "./dtos/file-upload-status.dto";

export const interfaceReducer = createReducer(
    initialState,
    on(interfaceActions.showNewModal, (state, {kind}) => ({
        ...state,
        activeNewModal: kind,
    })),
    on(interfaceActions.clearFileUpload, (state, {fileId}) => {
        const fileUploadStatuss = {...state.fileUploadStatuss}
        delete fileUploadStatuss[fileId]
        return {
            ...state,
            fileUploadStatuss
        };
    }),
    on(interfaceActions.clearFileUploads, (state) => {
        return {
            ...state,
            fileUploadStatuss: {}
        };
    }),
    on(
        interfaceActions.setFileUploadStatus,
        (state, fileUploadStatus: FileUploadStatus) => {
            const fileUploadStatuss = {...state.fileUploadStatuss};
            const newStatus = {...fileUploadStatus}
            if (!Object.keys(fileUploadStatuss).includes(fileUploadStatus.id)) {
                fileUploadStatuss[fileUploadStatus.id] = fileUploadStatus;
                return {...state, fileUploadStatuss}
            }
            let oldStatus = {...state.fileUploadStatuss[fileUploadStatus.id]}
            oldStatus = {...oldStatus, ...newStatus}
            fileUploadStatuss[fileUploadStatus.id] = oldStatus;
            return {
                ...state,
                fileUploadStatuss,
            };
        },
    ),
    on(interfaceActions.closeContextMenu, (state) => {
        return {
            ...state,
            contextMenuOpen: false,
        }
    }),
    on(interfaceActions.openContextMenu, (state) => {
        return {
            ...state,
            contextMenuOpen: true,
        }
    })
);
